import { combineReducers } from 'redux';
import { sitemap } from './sitemap';

export default combineReducers({
  sitemap,
});
